<template>
    <div class="content">
        <div>请联系您的毕马威项目经理为您分配KCC站点的权限角色，然后单击<span @click="goBack" class="click-pointer">此处</span>重新登录KCC。如有任何问题，请联系毕马威KCC支持团队cnfmkpmgclicbt@kpmg.com！</div>
        <div>Please contact your KPMG engagement manager to assign you with a role within KCC and then login to KCC by clicking <span @click="goBack" class="click-pointer">here</span>. Any issues, please contact KCC Help Desk at cnfmkpmgclicbt@kpmg.com!</div>
    </div>
</template>
<script>
export default {
    methods: {
        goBack() {
            sessionStorage.removeItem('JSESSIONID')
            localStorage.removeItem('JSESSIONID')
            sessionStorage.removeItem('siteClassification')
            this.$store.commit('common/setUser', {})
            this.$store.commit('common/setSite', {})
            this.$store.commit('common/setEntity', {})
            this.$router.push('/login')
        },
    }
}
</script>
<style scoped>
.content {
    background: #ccc;
    height: 100%;
    padding: 20px;
}
.content div{
    margin-bottom: 20px;
    white-space: pre-wrap;
}
.click-pointer{
    text-decoration: underline;
    color: rgb(65, 138, 179);
    font-weight: bolder;
    cursor: pointer;
}
</style>
